import { Container, Flex, Heading, Image } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

export default function GuiaRentCustomer() {
    return (
        <>
            <Header />
            <Head>
                <title>GuiaRent | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/lading-guiarent" />
                <link
                    rel="alternate"
                    href="https://grupoguia.mx/lading-guiarent"
                    hrefLang="es-mx"
                />
            </Head>
            <Container
                maxW={{ base: "md", md: "6xl" }}
                paddingTop={{ base: "50px", md: "100px" }}
                paddingBottom={{ base: "50px", md: "40px" }}
                textAlign="center"
                my="32"
                mx="auto"
            >
                <Flex direction="column" mb="15vh">
                    <Heading
                        as="h1"
                        fontSize={{ base: "3xl", sm: "4xl", md: "6xl" }}
                        fontWeight="bold"
                        mb="12"
                        color="#E81D75"
                    >
                        ¡Felicidades!
                    </Heading>
                    <Heading as="h2" my="4" fontSize={{ base: "lg", sm: "xl", md: "3xl" }}>
                        Ya diste el primer paso para rentar tu propiedad con{" "}
                        <span style={{ color: "#E81D75" }}>
                            <Image
                                src="https://media.grupoguia.mx/assets/home-page/logos/logo-guiarent.webp"
                                w="64"
                                mx="auto"
                                mb="8"
                                mt="4"
                                alt="simple icon"
                            />
                        </span>
                    </Heading>
                    <Heading color="accent.500" fontSize={{ base: "md", sm: "lg", md: "xl" }}>
                        en un momento un asesor te contactará
                    </Heading>
                </Flex>
                <Flex>
                    <Footer esGuiaRent={false} />
                </Flex>
            </Container>
        </>
    );
}
